// extracted by mini-css-extract-plugin
export var cost = "cost-module--cost--a6d42";
export var cost__blockBtn = "cost-module--cost__block-btn--53243";
export var cost__btn = "cost-module--cost__btn--1a040";
export var cost__col = "cost-module--cost__col--f6afb";
export var cost__heading = "cost-module--cost__heading--5f42e";
export var cost__info = "cost-module--cost__info--725b0";
export var cost__item = "cost-module--cost__item--f0f51";
export var cost__list = "cost-module--cost__list--95736";
export var cost__priceColor = "cost-module--cost__price-color--a7164";
export var cost__priceSub = "cost-module--cost__price--sub--943e0";
export var cost__priceText = "cost-module--cost__price-text--69367";
export var cost__priceWrapper = "cost-module--cost__price-wrapper--e8281";
export var cost__row = "cost-module--cost__row--5b956";
export var cost__sub = "cost-module--cost__sub--bc1cf";
export var cost__subBtn = "cost-module--cost__sub-btn--e937a";
export var cost__title = "cost-module--cost__title--a19d9";
export var cost__undertext = "cost-module--cost__undertext--4ffec";
export var cost__wrapper = "cost-module--cost__wrapper--3ef2f";
export var monthSmall = "cost-module--month-small--f9381";